export default class OperatorTagService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('OperatorTags', params)
	}

	createEntity(params){
		return this.apiService.callPost('OperatorTags', params);
	}

	updateEntity(id, params){
		return this.apiService.callPut('OperatorTags/'+id, params);
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('OperatorTags/' + id, params)
	}

	searchTagsByName(params){
		return this.apiService.callGet('OperatorTags/search', params);
	}
}



// WEBPACK FOOTER //
// ./src/service/OperatorTagService.js